import { defineStore } from "pinia";
import { SearchState } from "@/stores/search/types.ts";

const useSearchStore = defineStore("search", {
  state: (): SearchState => ({
    visitedItems: [],
  }),
  actions: {
    clearVisitedItems() {
      this.visitedItems = [];
    },
    addVisitedItem(id: string) {
      if (!this.visitedItems.includes(id)) {
        this.visitedItems.push(id);
      }
    },
  },
  getters: {
    getVisitedItems(): string[] {
      return this.visitedItems;
    },
  },
});

export { useSearchStore };
